import Vue from 'vue';

const DEFAULT = 'default';

class uploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then((file) => {
      const body = new FormData();
      const options = {
        resize: {
          width: 1000,
          height: 1000,
        },
      };

      body.append('type', 'image');
      body.append('file', file);
      body.append('options', JSON.stringify(options));

      return Vue.axios.post('uploads', body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(({ data }) => ({
          [DEFAULT]: data.url,
        }));
    });
  }

  abort(err) {
    console.error({ err, loader: this.loader });
  }
}

export default uploadAdapter;
